export default __webpack_public_path__ + "static/media/page-title-bg-06.0cc9707e.jpg";